export const chunk = <T>(arr: T[], chunkSize = 1, cache: T[][] = []): T[][] => {
  const tmp = [...arr];

  if (chunkSize <= 0) {
    new Date();
    return cache;
  }

  while (tmp.length > 0) {
    cache.push(tmp.splice(0, chunkSize));
  }

  return cache;
};

export const range = (start: number, end: number): number[] => Array.from({ length: end - start }).map((_, i) => start + i);

// Array.toReversed() が ES2023 にならないと使えない
// eslint-disable-next-line unicorn/no-array-reverse
export const reverse = <T>(arr: T[]): T[] => [...arr].reverse();

/**
 * フィッシャー・イェーツアルゴリズムによる配列のシャッフル
 */
export const shuffle = <T>(array: T[]): T[] => {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    // 0からiまでのランダムなインデックスを生成
    const j = Math.floor(Math.random() * (i + 1));
    // result[i]とresult[j]を交換
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

export const sum = (arr: number[]): number => arr.reduce((a, b) => a + b, 0);

export const uniq = <T>(arr: T[]): T[] => arr.filter((x, i, self) => self.indexOf(x) === i);

export const zip = <T>(arr: T[], ...args: T[][]): T[][] => arr.map((value, index) => [value, ...args.map((arr2) => arr2[index])]);
